import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import bengaluruImage from '../../assets/images/bangalore-vidhana.jpg';
import hyderabadImage from '../../assets/images/Hyderabad.jpg';
import chennaiImage from '../../assets/images/chennai-marina.jpg';
import mumbaiImage from '../../assets/images/mumbai-gateway.jpg';

const destinations = [
  {
    name: "Bangalore, Karnataka",
    price: "₹499/night",
    image: bengaluruImage,
  },
  {
    name: "Hyderabad, Telangana",
    price: "₹499/night",
    image: hyderabadImage,
  },
  {
    name: "Chennai, Tamil Nadu",
    price: "₹499/night",
    image: chennaiImage,
  },
  {
    name: "Mumbai, Maharashtra",
    price: "₹599/night",
    image: mumbaiImage,
  },
];

const DestinationsSection = () => {
  const navigate = useNavigate();

  const handleCityClick = (fullCityName: string) => {
    const cityName = fullCityName.split(',')[0].trim(); // Extract only the city name

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const checkInDate = today.toISOString().split('T')[0];
    const checkOutDate = tomorrow.toISOString().split('T')[0];

    const queryParams = new URLSearchParams();
    queryParams.append('keyword', cityName);
    queryParams.append('checkin', checkInDate);
    queryParams.append('checkout', checkOutDate);
    queryParams.append('male_guests', '1');
    queryParams.append('female_guests', '0'); // Assuming 0 female guests by default
    queryParams.append('accommodation_type', 'Bed'); // Shared bed by default

    navigate(`/guest-search-results?${queryParams.toString()}`);
  };

  return (
    <section className="bg-secondary py-20 md:py-28">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-foreground mb-4">
            Popular Destinations
          </h2>
          <p className="text-secondary-foreground/70 text-lg max-w-2xl mx-auto">
            Explore the places everyone's talking about
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {destinations.map((dest, index) => (
            <motion.div
              key={dest.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -8, scale: 1.02 }}
              className="group cursor-pointer"
              onClick={() => handleCityClick(dest.name)}
            >
              <div className="bg-card rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={dest.image}
                    alt={dest.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3 className="text-lg font-semibold text-white">{dest.name}</h3>
                  </div>
                </div>
                <div className="p-4 bg-card">
                  <p className="text-primary font-medium">
                    Beds from <span className="text-lg font-bold">{dest.price}</span>
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DestinationsSection;
